import { Routes } from '@angular/router';
import { SignoutComponent } from './components/signout/signout.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';

export const authRoutes: Routes = [
    {
        path: 'sign-up',
        component: SignUpComponent,
        outlet: 'auth'
    },
    {
        path: 'sign-in',
        component: SignInComponent,
        outlet: 'auth'
    },
    {
        path: 'sign-out',
        component: SignoutComponent
    }
];
